export default __webpack_public_path__ + "static/media/menu-light.e36517e5.svg";